import { ErrorSource } from '@datadog/browser-core';
import { StatusType } from './logger';
export function reportAgentError(error, lifeCycle) {
    lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
        rawLogsEvent: {
            message: error.message,
            date: error.startClocks.timeStamp,
            error: {
                origin: ErrorSource.AGENT, // Todo: Remove in the next major release
            },
            origin: ErrorSource.AGENT,
            status: StatusType.error,
        },
    });
}
//# sourceMappingURL=reportAgentError.js.map